import { useLazyQuery } from "@apollo/client";
import {
  Box,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  FormControl,
  Stack,
  Pagination,
  Button
} from "@mui/material";
import { table } from "./helper"
import Loader from "pages/build-test/loader";
import { useEffect, useState } from "react";
import NoDataFound from "shared/molecules/no-data";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { GET_VENDOR_PROJECT_USERS } from "utils/graphql/services/live-classes/queries";
import { VendorProjectUserFilter } from "./filter";
import ContentRight from "shared/molecules/content-right";
import { Link } from "react-router-dom";
import liveClassClientService from "utils/graphql/liveclassClient";
import { utcToIst } from "utils/time-util/utcIstTime";
import CollapsibleTable from "shared/organisms/tables/collapsible-table";


export default function VendorProjectUsers() {

  const [searchPayload, setSearchPayload] = useState({})
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [clearValuesTrigger, setClearValuesTrigger] = useState()

  const [getVendorProjectUsersList, { loading, error, data }] = useLazyQuery(
    GET_VENDOR_PROJECT_USERS,
    {
      client: liveClassClientService,
    }
  )

  useEffect(() => {
    getVendorProjectUsersList({
      variables: {
        input: {
          limit: limit,
          offset: (page - 1) * limit,
          ...searchPayload,
        },
      },
    });
  }, [page, limit, searchPayload])

  const vendorProjectUsersData=
    data?.getVendorProjectUsers?.vendorProjectUsers?.map((item: any) => ({
      ...item,
      projectName:item.projects?.map((p:any)=> p?.name).join(", "),
      createdAt: utcToIst(item.createdAt),
      updatedAt: utcToIst(item.updatedAt),
    })) || [];
  // if (showLoading) return <p>Loading...</p>;
  return (
    <>
      <ContentRight>
        <Link to="vendor-project-users/create" >
          <Button variant="contained">Create Vendor Project Users</Button>
        </Link>
      </ContentRight>

      <TypographyHeading sx={{ mb: 2, mt: 3, fontSize: "25px" }}>
        Vendor Project Users
      </TypographyHeading>

      <VendorProjectUserFilter
        setSearchPayload={setSearchPayload}
        setPage={setPage}
        clearValuesTrigger={clearValuesTrigger}
      />

      <Paper elevation={2} sx={{ p: 2, mt: 3 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <FormControl size="small" sx={{ width: 140 }}>
            <InputLabel>Show Entries</InputLabel>
            <Select
              value={limit}
              label="Show Entries"
              onChange={(e) => {
                setLimit(Number(e.target.value));
                setPage(1); // reset to first page
              }}
            >
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
              <MenuItem value={500}>500</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <div>
          {loading && <Loader />}
          {!loading && data?.getVendorProjectUsers?.vendorProjectUsers?.length > 0 ? (
            <CollapsibleTable
              data={vendorProjectUsersData || []}
              table={table}
              id="id"
              name="id"
              rowsPerPageCount={limit}
              style="false"
              totalRecords={data?.getVendorProjectUsers?.totalCount || 0}
              paginationSegmentApi="false"
              viewSecondaryData="false"
              showPaginationFooter={false}
            />
          ) : (
            <div>{!loading && <NoDataFound message="No Data Found" />}</div>
          )}
        </div>

        <Box sx={{ marginTop: "20px" }}>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Pagination
              count={
                Math.ceil(data?.getVendorProjectUsers?.totalCount / limit) || 1
              }            
              page={page}
              onChange={(e, value) => setPage(value)}
              color="primary"
              size="medium"
            />
          </Stack>
        </Box>
      </Paper>
    </>
  );
}
